import React from 'react';
import elfsightMapping from './elfsightMapping.json';

type ElfsightMapping = Record<string, string>;

interface IProps {
  uuid: string;
}

const instagramMap = elfsightMapping as ElfsightMapping;

const ElfsightInstagramWidget = ({ uuid }: IProps) => {
  const className = instagramMap?.[String(uuid)];

  if (!className) {
    return null;
  }

  return (
    <>
      <script src="https://elfsightcdn.com/platform.js" async />
      <div className={className} data-elfsight-app-lazy />
    </>
  );
};

export default ElfsightInstagramWidget;
